import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import UserLink from '../../../User/Link/UserLink';
import BasicUserName from '../../../User/BasicUserName';
import { getMoreByLinkType } from '../../helpers';
import s from './MoreByAuthor.scss';
const MoreByAuthor = ({ contentType, deviation, className })=>{
    const { deviationId, author } = deviation;
    const foryou_gallery = useFlag('foryou_gallery');
    if (!author) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(UserLink, {
        className: classnames(s['root'], className),
        user: author,
        linkTo: getMoreByLinkType(contentType),
        anchor: true,
        deviationIdSeed: foryou_gallery ? deviationId : undefined
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: `sidebar.blockTitle.${contentType}`
    }, "More things by ", /*#__PURE__*/ React.createElement(BasicUserName, {
        user: author
    })));
};
MoreByAuthor.displayName = 'MoreByAuthor';
export default MoreByAuthor;

//# sourceMappingURL=MoreByAuthor.js.map